import { Col, Row as AntRow } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Page } from 'components/molecules/page';
import { TemplateId } from 'data/templates/api';
import { TemplateDetailHeader } from '../../commons';
import { ProjectTemplateDetailView } from './detail-view';
import { ProjectTemplatePlanListV2 } from './list-view';

const LeftColWidth = 615;

const Row = styled(AntRow)`
  background: var(--coolest-gray-20);
  height: 100%;
`;

const LeftCol = styled(Col)`
  background: var(--white-100);
  border-right: solid 1px var(--border-color);
  width: ${LeftColWidth}px;
  max-width: ${LeftColWidth}px;
  float: left;
  overflow: hidden;
`;

const RightCol = styled(Col)`
  width: calc(100% - ${LeftColWidth}px);
  height: 100%;

  .ant-tabs.ant-tabs-top {
    height: 100%;
  }

  .ant-tabs-content.ant-tabs-content-top {
    height: 100%;
  }

  [role='tablist'] {
    margin-bottom: 0;
  }
`;

export const ProjectTemplatePlan: FC<{ templateId: TemplateId }> = ({
  templateId,
}) => {
  return (
    <Page>
      <TemplateDetailHeader />
      <Page.Content>
        <Row>
          <LeftCol>
            <ProjectTemplatePlanListV2 />
          </LeftCol>
          <RightCol>
            <ProjectTemplateDetailView templateId={templateId} />
          </RightCol>
        </Row>
      </Page.Content>
    </Page>
  );
};
